import './App.css';
import { NavBar } from './components/NavBar';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { AuthContextProvider } from './common/AuthContextProvider';
import { Profile } from './pages/Profile';
import { FeaturesPage } from './pages/Features';
import { QueryProvider } from './common/QueryProvider';
import { LoginBox } from './components/LoginBox';
import { ListItemsPage } from './pages/ListItemsPage';
import { ListWarehousesPage } from './pages/ListWarehousesPage';


function App() {
  return (
    <div className="App">
      <AuthContextProvider>
        <QueryProvider>
          <BrowserRouter>
            <NavBar />
            <LoginBox />

            <div className='App-body'>
              <Routes>
                <Route path="" element={<Home />} />
                <Route path="/inventory" element={<ListItemsPage />} />
                <Route path="/warehouse" element={<ListWarehousesPage />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/features" element={<FeaturesPage />} />
              </Routes>
            </div>
          </BrowserRouter>
        </QueryProvider>
      </AuthContextProvider>
    </div>
  );
}

export default App;
